export default function NotificationPopoverListItemReadStatus({ read }) {
  return (
    <div>
      <i
        className={[
          'text-xs',
          read ? 'far fa-circle text-gray-200' : 'fas fa-circle text-gray-400',
        ].join(' ')}
      />
    </div>
  );
}
